import { createContext } from 'react';
import { Stripe } from '@stripe/stripe-js';

export const StripeContext = createContext<Promise<Stripe | null> | undefined>(undefined);
